module.exports = __webpack_public_path__ + "static/media/Gas.43b80266.svg";